(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stylstime-hero-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    var root = document.getElementById('st-carousel-{{ section.id }}');
    if (!root) return;
    var track = root.querySelector('.st-carousel__track');
    var slides = Array.from(root.querySelectorAll('.st-carousel__slide'));
    var dots = Array.from(root.querySelectorAll('.st-carousel__dot'));
    var prevBtn = root.querySelector('.st-carousel__arrow--prev');
    var nextBtn = root.querySelector('.st-carousel__arrow--next');
    var counterCurrent = root.querySelector('.st-carousel__counter-current');
    var total = slides.length;
    var current = 0;
    var timer;
    var isAnimating = false;
    if (total <= 1) return;
    function pad(n) { return n < 10 ? '0' + n : String(n); }
    function goTo(index, fromUser) {
      if (isAnimating) return;
      if (index < 0) index = total - 1;
      if (index >= total) index = 0;
      if (index === current) return;
      isAnimating = true;
      slides[current].classList.remove('is-active');
      slides[current].setAttribute('aria-hidden', 'true');
      dots[current].classList.remove('is-active');
      dots[current].setAttribute('aria-current', 'false');
      current = index;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      slides[current].classList.add('is-active');
      slides[current].setAttribute('aria-hidden', 'false');
      dots[current].classList.add('is-active');
      dots[current].setAttribute('aria-current', 'true');
      if (counterCurrent) counterCurrent.textContent = pad(current + 1);
      setTimeout(function () { isAnimating = false; }, 800);
      if (fromUser) resetTimer();
    }
    function startTimer() { timer = setInterval(function () { goTo(current + 1, false); }, 5500); }
    function resetTimer() { clearInterval(timer); startTimer(); }
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1, true); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1, true); });
    dots.forEach(function (dot, i) { dot.addEventListener('click', function () { goTo(i, true); }); });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1, true); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1, true); }
    });
    var touchStartX = 0;
    var touchStartY = 0;
    root.addEventListener('touchstart', function (e) { touchStartX = e.touches[0].clientX; touchStartY = e.touches[0].clientY; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      var dx = touchStartX - e.changedTouches[0].clientX;
      var dy = touchStartY - e.changedTouches[0].clientY;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 48) { goTo(dx > 0 ? current + 1 : current - 1, true); }
    }, { passive: true });
    root.addEventListener('mouseenter', function () { clearInterval(timer); });
    root.addEventListener('mouseleave', startTimer);
    startTimer();
  })();

  } catch(e) { console.error(e); }
})();
})();
